import styled from '@emotion/styled'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import { colors } from '../../../../../../__styling/settings/colors'
import { transition } from '../../../../../../__styling/style-mixins'
import { IconPlay } from '../../../../../../icons/IconPlay/IconPlay'
import { IconStop } from '../../../../../../icons/IconStop/IconStop'
import { IconSpinner } from '../../../../../../icons/IconSpinner/IconSpinner'
import { themedValue } from '../../../../../../__styling/themed-value'

interface StyledControlButtonProps {
    bigButton?: boolean
}

export const StyledControlButton = styled('button')<StyledControlButtonProps>(
    ({ bigButton, theme }) => ({
        display: 'inline-block',
        position: 'relative',
        width: calcRem(bigButton ? 56 : 40),
        height: calcRem(bigButton ? 56 : 40),
        backgroundColor: themedValue(theme, {
            perthnow: colors.perthnow.redRuby,
            fallback: colors.thewest.westblue,
        }),
        border: 'none',
        borderRadius: '100%',
        boxShadow: '0 0 16px rgba(0,0,0,0.5)',
        cursor: 'pointer',
        outline: 0,
        ...transition({
            properties: ['transform', 'background-color'],
            speed: 'fast',
        }),

        '&:hover': {
            transform: 'scale(1.05)',
        },

        '&:active, &:focus': {
            transform: 'scale(1)',
        },
    }),
)

export const StyledPlayIcon = styled(IconPlay)<StyledControlButtonProps>(
    ({ bigButton }) => ({
        display: 'block',
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginLeft: bigButton ? 3 : 2, // used here to visually align the icon - would use calc but thats not supported in ie11 transforms
        transform: 'translate(-50%,-50%)',
        width: calcRem(bigButton ? 24 : 16),
        height: calcRem(bigButton ? 32 : 20),
        fill: colors.white,
    }),
)

export const StyledStopIcon = styled(IconStop)<StyledControlButtonProps>(
    ({ bigButton }) => ({
        display: 'block',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        width: calcRem(bigButton ? 22 : 15),
        height: calcRem(bigButton ? 22 : 15),
        fill: colors.white,
    }),
)

export const StyledSpinner = styled(IconSpinner)<StyledControlButtonProps>(
    ({ bigButton }) => ({
        display: 'block',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50% ,-50%)',
        width: calcRem(bigButton ? 28 : 18),
        height: calcRem(bigButton ? 28 : 18),
        fill: colors.white,
    }),
)
